import React from "react";
import debounce from "lodash/debounce";
import get from "lodash/get";
import compose from "lodash/flowRight";
import { connect } from "react-redux";

import GDPROptIn from "./GDPROptIn";
import requiresOptIn from "utils/requiresOptIn";
import { Button, Form, Footer, CountrySelect } from "auth/components";
import { Error } from "account/styles";
import { LegalAgreement } from "auth/Links";
import { TextInput, InputLabel } from "components/Form";
import { EMAIL_IN_USE } from "account/helpers/user";
import {
  checkEmail,
  resetState,
  isEmailAddressInUse,
  CHECK_EMAIL_DEBOUNCE_MS,
} from "auth/modules/sign-up";

const name = get(window, "Auth.organization_name");

class SignUpWithToken extends React.Component {
  state = {
    country: null,
    gdprOptIn: false,
    isSubmitClicked: false,
  };

  onChangeFor(prop) {
    return e => {
      const value =
        e.target.type == "checkbox" ? e.target.checked : e.target.value;
      this.setState({ [prop]: value || "" });
    };
  }

  onKeyUpForEmail = debounce(email => {
    if (email) {
      this.props.checkEmail(email);
    } else {
      this.props.resetState();
    }
  }, CHECK_EMAIL_DEBOUNCE_MS);

  onSubmit = e => {
    this.setState({ isSubmitClicked: true });
  };

  render() {
    const { isEmailAddressInUse } = this.props;
    const { isSubmitClicked } = this.state;
    const isSubmitButtonDisabled = isSubmitClicked || isEmailAddressInUse;

    return (
      <Form
        action="/users"
        title={`Register as a member of the ${name} Organization on AppOptics`}
        onSubmit={this.onSubmit}
      >
        <InputLabel>
          Valid Business Email *
          <TextInput
            name="user[email]"
            placeholder="example@email.com"
            type="email"
            onKeyUp={({ target }) => this.onKeyUpForEmail(target.value)}
            className={isEmailAddressInUse ? "error" : null}
          />
          {isEmailAddressInUse && <Error>{EMAIL_IN_USE}</Error>}
        </InputLabel>

        <InputLabel>
          Password *
          <TextInput name="user[password]" type="password" />
        </InputLabel>

        <CountrySelect
          onChangeFor={this.onChangeFor("country")}
          country={this.state.country}
        />

        {requiresOptIn(this.state.country) && (
          <GDPROptIn
            country={this.state.country}
            gdprOptIn={this.state.gdprOptIn}
            onOptIn={this.onChangeFor("gdprOptIn")}
          />
        )}

        <Button type="submit" disabled={isSubmitButtonDisabled}>
          Join Organization
        </Button>

        <Footer>
          <LegalAgreement />
        </Footer>
      </Form>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    isEmailAddressInUse: isEmailAddressInUse(state, props),
  };
}

function mapDispatchToProps(dispatch, props) {
  return {
    checkEmail: email => dispatch(checkEmail(email)),
    resetState: () => dispatch(resetState()),
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SignUpWithToken
);
